import { DmnSymbolId } from './dmnSymbols';

export interface DmnIconMarkup {
  viewBox: string;
  markup: string;
}

/** DMN 1.3 glyphs from DMN_VSM_RACI visual reference. */
export const DMN_ICON_MARKUP: Record<DmnSymbolId, DmnIconMarkup> = {
  decision: {

    viewBox: '6.5 6.5 147.0 67.0',

    markup: `<rect x="8" y="8" width="144" height="64" rx="10" ry="10" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  inputData: {

    viewBox: '6.5 6.5 147.0 67.0',

    markup: `<rect x="8" y="8" width="144" height="64" rx="32" ry="32" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  businessKnowledgeModel: {

    viewBox: '6.5 6.5 147.0 67.0',

    markup: `<path d="M 8 26 L 26 8 L 152 8 L 152 54 L 134 72 L 8 72 Z" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  knowledgeSource: {

    viewBox: '6.5 6.5 147.0 63.0',

    markup: `<path d="M 8 8 L 152 8 L 152 58 C 140 68, 128 68, 116 60 C 104 52, 92 52, 80 60 C 68 68, 56 68, 44 60 C 32 52, 20 52, 8 60 Z" fill="white" stroke="#1A202C" stroke-width="2"/>`,

  },
  decisionService: {

    viewBox: '6.5 6.5 167.0 87.0',

    markup: `<rect x="8" y="8" width="164" height="84" rx="10" ry="10" fill="white" stroke="#1A202C" stroke-width="2"/><line x1="8" y1="50" x2="172" y2="50" stroke="#1A202C" stroke-width="1.5" stroke-dasharray="4,3"/>`,

  },
  informationRequirement: {

    viewBox: '8.5 11.5 147.0 17.0',

    markup: `<line x1="10" y1="20" x2="140" y2="20" stroke="#1A202C" stroke-width="2"/><polygon points="140,13 154,20 140,27" fill="#1A202C"/>`,

  },
  knowledgeRequirement: {

    viewBox: '8.5 11.5 147.0 17.0',

    markup: `<line x1="10" y1="20" x2="140" y2="20" stroke="#1A202C" stroke-width="2" stroke-dasharray="5,4"/><polygon points="140,13 154,20 140,27" fill="#1A202C"/>`,

  },
  authorityRequirement: {

    viewBox: '8.5 12.5 147.0 15.0',

    markup: `<line x1="10" y1="20" x2="140" y2="20" stroke="#1A202C" stroke-width="2" stroke-dasharray="5,4"/><circle cx="148" cy="20" r="6" fill="#1A202C"/>`,

  },
  textAnnotation: {

    viewBox: '10.5 6.5 16.0 47.0',

    markup: `<path d="M 25 8 L 12 8 L 12 52 L 25 52" fill="none" stroke="#1A202C" stroke-width="2"/>`,

  },
  association: {

    viewBox: '8.6 18.6 142.8 2.8',

    markup: `<line x1="10" y1="20" x2="150" y2="20" stroke="#1A202C" stroke-width="1.8" stroke-dasharray="2,4"/>`,

  },
};
